export default "__VITE_ASSET__Ba2Hb4px__"